import { render } from "./gf6satinfo.vue?vue&type=template&id=0625be3f&scoped=true"
const script = {}

import "./gf6satinfo.vue?vue&type=style&index=0&id=0625be3f&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0625be3f"]])

export default __exports__